module.exports = __webpack_public_path__ + "static/media/allot_logo.634d5526.png";


//////////////////
// WEBPACK FOOTER
// ./public/allot_logo.png
// module id = 6393
// module chunks = 0